import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: #f8f9fa;
  border-left: 4px solid #2563eb;
  padding: 20px 24px;
  margin: 32px 0;
  border-radius: 0 8px 8px 0;

  p {
    font-size: 16px;
    line-height: 1.7;
    color: #1e293b;
    margin: 0;
  }
`;

interface AnswerBlockProps {
  answer: string;
}

const AnswerBlock: React.FC<AnswerBlockProps> = ({ answer }) => {
  if (!answer) return null;
  return (
    <Wrapper>
      <p>{answer}</p>
    </Wrapper>
  );
};

export default AnswerBlock;
